import { render, staticRenderFns } from "./OrderDet.vue?vue&type=template&id=1609a9ce&scoped=true"
import script from "./OrderDet.vue?vue&type=script&lang=js"
export * from "./OrderDet.vue?vue&type=script&lang=js"
import style0 from "./OrderDet.vue?vue&type=style&index=0&id=1609a9ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1609a9ce",
  null
  
)

export default component.exports